import { useState } from "react";
import Config from "../../Config";
import Account from "./Account";
import KSeF from "./KSeF";
 
 




function SettingsView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


 

      if(props.mainView.viewSelected == 'account')
    {
        document.title ="Ustawienia konta"; 
        return (
            <div className="econtent ">                                  
                  <Account  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }
    

    if(props.mainView.viewSelected == 'ksef')
    {
        document.title ="Certyfikaty KSeF"; 
        return (
            <div className="econtent ">                                  
                  <KSeF  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }

      
  

        return (
        <div className="econtent ">
             SettingsView - no selected menu position
        </div>
    );
}


export default SettingsView ;